// Log viewer (#247) — gate predicate for the header "📋 Logs" button and for the
// Log viewer's User Manual chapter.
//
// The Log viewer is the in-app CloudWatch browser: pick one of the Lambda log
// groups, set a time window, search a keyword, and read the events with any
// embedded JSON payload pretty-printed. It replaces squinting at the AWS
// CloudWatch console for the high-volume Lambdas.
//
// Returns true ONLY when the user is logged in AND their Users document's
// `screenAccessList` contains the `"logs"` token.
//
// Access source: managed in the "Tab Access" section of UserDetailModal, which
// reads/writes `Users.screenAccessList` — the same array + pattern that gates
// Compass / Dashboard / Time Machine / Ticket Master (#202). Not for general
// schedulers; 5 production users hold it today.
//
// Why `.includes(token)` (strict membership, matching the sibling predicates):
// the token is either present or it isn't — no truthiness coercion — so a future
// schema change can't accidentally open the gate.
//
// Extracted rather than left inline: the check now runs in TWO places (the
// header button and the manual chapter's visibility), and those two disagreeing
// is precisely the bug this prevents — a user who cannot open the tool being
// told how to use it, or the reverse.
//
// NOTE this is deliberately NOT backend-mode aware. An earlier version of the
// Logs screen was a Realm→TanStack comparison tool with no role in the Convex
// path, so the header hid it from convexOnly users. The CloudWatch viewer reads
// AWS through the queries Lambda regardless of backend, so that hide is gone.

export function canAccessLogs(mongoUser, tsUserDocument) {
  return (
    Boolean(mongoUser) &&
    Array.isArray(tsUserDocument?.screenAccessList) &&
    tsUserDocument.screenAccessList.includes("logs")
  );
}
